import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaShip, FaAnchor, FaBoxesPacking } from "react-icons/fa6";
import "./Testimonies.css";

const services = [
  { icon: <FaShip/>, title: "Shipping agency", text: "Full agency representation from pre-arrival to final sailing." },
  { icon: <FaAnchor/>, title: "Marine & offshore support", text: "Offshore, jetty and ship-to-ship transfer operations." },
  { icon: <FaBoxesPacking/>, title: "Logistics & customs clearing", text: "End-to-end clearing that keeps cargo moving." },
];

export const Testimonies = () => (
  <>
    <section className="what-we-do">
      <p className="section-label">What we do</p>
      <h2>Three ways we keep your operation moving</h2>
      <div className="what-we-do-grid">
        {services.map((s) => (
          <div key={s.title}>
            <div className="what-we-do-icon">{s.icon}</div>
            <h3>{s.title}</h3>
            <p>{s.text}</p>
          </div>
        ))}
      </div>
      <Link to="/services" className="text-link">See all services <FaArrowRight/></Link>
    </section>
    {/* "The Peak difference" section hidden for now */}
  </>
);
